import { TypeReferentielFormationLibelle } from '@/features/domaine/types/opco'
import { ObjectifFormationLibelle } from '@/features/domaine/types/opco/Demande/AF'
import { ReferenceProjetLibelle } from '@/features/domaine/types/opco/Demande/AF/ReferenceProjet'
import { TailleEntrepriseLibelle } from '@/features/domaine/types/opco/Demande/AF/TailleEntreprise'
import { objectToDropdownItems } from '@/features/interface/shared/tools'

export const objectifFormationItems = objectToDropdownItems(ObjectifFormationLibelle)
export const typeReferentielFormationItems = objectToDropdownItems(TypeReferentielFormationLibelle)
export const tailleEntrepriseItems = objectToDropdownItems(TailleEntrepriseLibelle)
export const referenceProjetItems = objectToDropdownItems(ReferenceProjetLibelle)
